import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import classNames from "classnames";
import "./styles.css";
import {
  daysOfWeek,
  daysOfWeekMobile,
  createDaysForCurrentMonth,
  createDaysForNextMonth,
  createDaysForPreviousMonth,
  isWeekendDay,
  getMonthDropdownOptions,
  getYearDropdownOptions
} from "./helpers";
import CustonSelect from '../../components/ayrshare/posts/custonSelect'
import endpoints from '../../constants/endpoints';
import useProfileState from '../../hooks/ayrshare/useProfileState';
import backEnd from '../../constants/backEnd';
import moment from 'moment'
import { Box, Dialog, DialogContent, DialogTitle, Tooltip, styled, tooltipClasses } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PostPanel from '../../components/ayrshare/posts/postPanel';
import MyModal from '../../components/myModal';
import AdPostModal from './adPostModal';
import MyLabel from '../../components/myLabel';
import MyButton from '../../components/myButton';
import AutocompleteCalendar from './autocomplete-calendar';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const imagesMapped = {
  twitter: {
    text:'X/Twitter',
    backgroundColor:'#F0F0F0',
    color:'black'
  },
  twitterActive: {
    text:'X/Twitter',
    backgroundColor:'#14171A',
    color:'white'
  },
  linkedin: {
    text:'Linkedin',
    backgroundColor:'#F0F0F0',
    color:'black',
  },
  linkedinActive: {
    text:'Linkedin',
    backgroundColor:'#0e76a8',
    color:'white'
  },
  facebook: {
    text:'Facebook',
    backgroundColor:'#F0F0F0',
    color:'black'
  },
  facebookActive: {
    text:'Facebook',
    backgroundColor:'#4267B2',
    color:'white'
  },

  instagram: {
    text:'Instagram',
    backgroundColor:'#F0F0F0',
    color:'black'
  },
  instagramActive: {
    text:'Instagram',
    backgroundColor:'#E1306C',
    color:'white'
  },
  
  fbg: {
    text:'FB Groups',
    backgroundColor:'#F0F0F0',
    color:'black'
  },
  fbgActive: {
    text:'FB groups',
    backgroundColor:'#ff9d2e',
    color:'white'
  },
  
}

Calendar.propTypes = {
  className: PropTypes.string,
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className,  }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const style = {
  stack: {
      '@media (max-width: 600px)': {
          width:'100%',
      }
  },
  titleArea:{
      display:'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexDirection:'row',
      margin: '14px',
      width:'100%',
  },
  title:{
      margin: '0px',
      padding: '0px',
      fontSize: '14pt',
      fontWeight: 600,
      marginBottom: '10px'
  },
  panel: {
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
      backgroundColor: '#FFF',
      padding: '40px',
      marginBottom: '20px',
      '@media (max-width: 600px)': {
          minWidth: '100%',
      }
  },
  row: {
      display:'flex',
      flexDirection:'row',
      alignItems: 'center',
      gap: '5px',
      justifyContent:'space-between',
      '@media (max-width: 600px)': {
          flexDirection:'column',
      }
  },
  channel: {
      marginRight:'25px',
      marginLeft:'25px',
      display:'flex',
      flexDirection:'row',
      alignItems: 'center',
      gap: '5px',
      justifyContent:'space-between',
      '@media (max-width: 600px)': {
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '5px',
          marginRight:'0px',
          marginLeft:'0px',
      }
  },
  planDescription:{
      fontSize: '11pt',
      fontWeight: 600,
  },
  planButton:{
      fontSize: '11pt',
      fontWeight: 500,
      textDecoration: 'underline',
  },
  input:{
      marginBottom:'5px',
  },
  selectArea: {
      width: '200px',
      '@media (max-width: 600px)': {
          width: '100%',
          display:'none'
      }
  },
  postArea: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gap: '15px',
      '@media (max-width: 600px)': {
          gridTemplateColumns: '1fr',
      }
  },
  blueButton: {
      backgroundColor: '#376db4',
      marginRight: '50px',
      ':hover': {
          backgroundColor: '#598FD6',
      },

      '@media (max-width: 600px)': {
          marginRight: 0,
      }

  },
  blackButton: {
      backgroundColor: '#000',
      ':hover': {
          backgroundColor: '#555',
      }

  },
  cancelButton:{
      width: '180px',
      color:'black',
      backgroundColor: '#cfcfcf',
      ':hover': {
          backgroundColor: '#ebebeb',
      }
  },
  exitButton:{
      width: '180px',
  },

}


function MessageDialog({open, handleClose, handlerSuccess}) {
  
  return (
      <Dialog  open={open} onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
          <MyLabel component='p' text={" "}  />
      </DialogTitle>
      <DialogContent>
        <Box sx={{margin:'30px'}}>
          <Box sx={{display: 'flex', flexDirection:'row',justifyContent:'space-around', alignItems: 'center', width: '100%', margin:'10px'}}>
              <MyLabel component='p' text={"Are you sure you want to abandon the creation of this post? All information will be lost."}  />
          </Box>
          <Box sx={{display: 'flex', flexDirection:'row',justifyContent:'space-around', alignItems: 'center', width: '100%', margin:'10px'}}>
                  <MyButton 
                      sx={style.cancelButton}
                      onClick={handleClose}
                      text='no'
                      variant="contained" 
                      size="small"
                  />
                  <MyButton 
                      sx={{...style.exitButton, marginBottom:0}}
                      onClick={handlerSuccess}
                      text='yes'
                      variant="contained" 
                      size="small"
                      color='warning'
                  />
              </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}



const RenderDay = ({ profileSelected, dayClickedNow, calendarDayObject, postsInDay, setModalOpen, setDaysSelected, updateListPost}) => {
  const dayClickedNowProcessed = dayClickedNow === calendarDayObject.dateString
  const isToday = moment().format('YYYY-MM-DD') === moment(calendarDayObject.dateString).format('YYYY-MM-DD')
  const isAfter = moment(calendarDayObject.dateString).isAfter(moment())

  
  
  const handlerAddPost = () => {
    setDaysSelected(calendarDayObject.dateString)
    setModalOpen(true)
  }
  return (
    <div>
      {(isAfter || isToday) && window.innerWidth > 600 &&
      <Box  onClick={handlerAddPost}  sx={{float:'right',cursor:'pointer', fontSize:'0.8rem', marginRight:'0.8rem', marginTop:'0.5rem', color:'#721384'}}>
        <AddIcon sx={{ fontSize:'1rem', position:'relative', top:'4px', left:'3px'}} /> add post
        </Box>
      }
      <CalendarDayHeader dayClickedNow={dayClickedNowProcessed} calendarDayObject={calendarDayObject} isToday={isToday} />
      {postsInDay?.length > 2 ?
      <LightTooltip
      title={
        <Box>
<div style={{color:'black', fontWeight:'bold', textAlign:'center', marginTop:'0.2rem'}}>{moment(calendarDayObject.dateString).format('MMMM Do YYYY')}</div>

<ul style={{
columnGap: 2,
padding:'15px',
marginBlockStart: 0,
marginBlockEnd: 0,
}}>

{window.innerWidth > 600 ? postsInDay?.slice(2,postsInDay?.length).map((post, key) => (<Box width={'150px'}><PostPanel profileSelected={profileSelected} post={post} isCalendar  updateListPost={updateListPost} /> </Box>) ) : postsInDay?.length > 0 && <FiberManualRecordIcon style={{width:'8px', color:'#721384', zIndex:1,  left:'18px', position:'relative',}} />}
</ul>
</Box>
      }
      arrow
      interactive
      placement="top"
      
    >
                        <Box data-for={calendarDayObject.dateString} data-tip>
                        <Box sx={{display: 'flex',
  flexDirection: 'column', marginTop:'0.3rem', flexWrap: 'wrap',
  height: '140px'}}>
        {window.innerWidth > 600 ? postsInDay.slice(0,2).map((post, key) => (
          <PostPanel profileSelected={profileSelected} post={post} isCalendar updateListPost={updateListPost} />) ) : postsInDay?.length > 0 && <FiberManualRecordIcon style={{width:'8px', color:'#721384', position:'relative', zIndex:1, left:'18px', bottom:'9px', position:'relative'}} />
        }
        {postsInDay.length > 2 && window.innerWidth > 600 && <Box width={'100%'} textAlign={'center'} fontSize={'0.6rem'} fontWeight={'bold'} style={{cursor:'pointer'}}>{postsInDay.length - 2} more...</Box>}
      </Box>
      </Box>
                      </LightTooltip>
                    : window.innerWidth > 600 ? 
                    <Box data-for={calendarDayObject.dateString} data-tip>
                    <Box sx={{display: 'flex',
flexDirection: 'column', marginTop:'0.3rem', flexWrap: 'wrap',
height: '140px'}}>
    {window.innerWidth > 600 ? postsInDay.slice(0,2).map((post, key) => (
      <PostPanel profileSelected={profileSelected} post={post} isCalendar  updateListPost={updateListPost} />) ) : postsInDay?.length > 0 && <FiberManualRecordIcon style={{width:'120px', color:'#721384', position:'relative', zIndex:1, left:'18px', position:'relative'}} />
    }
    
  </Box>
  </Box> : <Box data-for={calendarDayObject.dateString} data-tip>
                    <ul style={{
                      display: 'flex',
                      columnCount:2,
                      flexDirection: 'column',
                      flexWrap: 'wrap',
                      padding:'15px 0',
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      
                    }}>
                      {window.innerWidth > 600 ? postsInDay.slice(0,2).map((post, key) => (<li style={{ listStyleType: 'none'}} key={key}>
                        <PostPanel profileSelected={profileSelected} post={post} isCalendar updateListPost={updateListPost} /></li>) ) : postsInDay?.length > 0 && <FiberManualRecordIcon style={{width:'8px', color:'#721384', zIndex:1, bottom:'20px', left:'18px', position:'relative'}} />
                      }
                    </ul>
                    </Box>
}
      
      
      
    </div>
  )
}
export default function Calendar() {
  const [modalOpen, setModalOpen] = useState(false)
  const [modal, setModal] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [isTodayClicked, setIsTodayClicked] = useState(false)
  const [isAfterClicked, setIsAfterClicked] = useState(false)
  const [daysSelected, setDaysSelected] = useState(null)
  const [mobilePosts, setMobilePosts] = useState([])
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false)
  const [yearAndMonth, setYearAndMonth] = useState([moment().year(), moment().month() + 1]);
  let currentMonthDays = createDaysForCurrentMonth(yearAndMonth[0], yearAndMonth[1]);
  let previousMonthDays = createDaysForPreviousMonth(
    yearAndMonth[0],
    yearAndMonth[1],
    currentMonthDays
  );

  
  
  
  let nextMonthDays = createDaysForNextMonth(yearAndMonth[0], yearAndMonth[1], currentMonthDays);
  let calendarGridDayObjects = [
    ...previousMonthDays,
    ...currentMonthDays,
    ...nextMonthDays
  ];

  const { socials, update, getListPost, connect, listPost, profileSelected, profiles } = useProfileState();

  const handlerGetListPost = (url, type, month, year) => getListPost.set(url, type, month, year);

  const updateListPost = () => {
    handlerGetListPost(`${backEnd.url}${endpoints.ayrshare.profilepost}${profileSelected.value}`, 'all',  yearAndMonth[1], yearAndMonth[0] )
    connect.set();
  }

  useEffect(() => {
    update.set();
  }, []);


  useEffect(() => {
    if (!modalOpen && profileSelected.value && profileSelected.value > 0){
      updateListPost()
    }
    
  }, [modalOpen]);

  useEffect(() => {
    if (!autoCompleteOpen && profileSelected.value && profileSelected.value > 0){
      updateListPost()
    }
    
  }, [autoCompleteOpen]);

  useEffect(() => {
    if (profileSelected.value && profileSelected.value > 0){
      updateListPost()
    }
  }, [profileSelected.value, yearAndMonth])

  const handleMonthSelect = (evt) => {
    let nextYear = yearAndMonth[0];
    let nextMonth = parseInt(evt.target.value, 10);
    setYearAndMonth([nextYear, nextMonth]);
  };

  const handleYearSelect = (evt) => {
    let nextMonth = yearAndMonth[1];
    let nextYear = parseInt(evt.target.value, 10);
    setYearAndMonth([nextYear, nextMonth]);
  };

  const daysOfWeekFormatted = window.innerWidth < 600 ? daysOfWeekMobile : daysOfWeek
  const [dayClickedNow, setDayClickedNow] = useState(null)
  return (
    <Box width={'100%'} display={'flex'} flexDirection={'column'}>

    <div className="calendar-root">
       <MyModal notClose={true} sx={{display: 'flex', top:'5%' }} title="Post" isOpen={modalOpen} setIsOpen={() => setDialogOpen(true)}>
        <AdPostModal setClose={() => setModalOpen(false)} profileSelected={profileSelected} socials={socials} daysSelected={daysSelected}/>
      </MyModal>
      <MessageDialog open={dialogOpen} handleClose={()=>setDialogOpen(false)} handlerSuccess={()=>{setModalOpen(!modalOpen);setDialogOpen(false)}} />
      <Box className="navigation-header" sx={{
        display:'grid', 
        gridTemplateColumns: '5fr 1fr',
        '@media (max-width: 600px)': {
          paddingBottom:'30px'
        }
      }}>
        {autoCompleteOpen && <AutocompleteCalendar month={yearAndMonth[1]} year={yearAndMonth[0]} autoCompleteOpen={autoCompleteOpen} setAutoCompleteOpen={setAutoCompleteOpen} profileSelected={profileSelected}/>}
      <Box height={10} marginTop={'15px'}>
        <select
          className="month-select"
          value={yearAndMonth[1]}
          onChange={handleMonthSelect}
        >
          {getMonthDropdownOptions(null, false, window.innerWidth < 600).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
        <select
          className="year-select"
          value={yearAndMonth[0]}
          onChange={handleYearSelect}
        >
          {getYearDropdownOptions(yearAndMonth[0]).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
        <MyButton
          onClick={() => setAutoCompleteOpen(true)}
          text='Auto Complete'
          variant="contained" 
          size="large"
          sx={{position:'relative', backgroundColor:'#6466e9', left:'12px', fontSize:'0.8rem',
          '@media (max-width: 600px)': {
            fontSize:'0.5rem'
        }}}
        />
        </Box>
         <Box sx={style.selectArea} marginBottom={2}>
                        <CustonSelect 
                            sx={style.select}
                            id='style'
                            label="Select a brand"
                            options={profiles.value}
                            value={profileSelected.value}
                            onChange={(e)=>profileSelected.set(e.target.value)}
                            noTranslate={true} 
                        />
                    </Box>
      </Box>
      <div className="days-of-week">
        {daysOfWeekFormatted.map((day, index) => (
          <div
            key={`${day}-${index}`}
            className={classNames("day-of-week-header-cell", {
              "weekend-day": [6, 0].includes(index)
            })}
          >
            {day.toUpperCase()}
          </div>
        ))}
      </div>
      <div className={window.innerWidth < 600 ? "days-grid-mobile" : "days-grid"} style={{height: calendarGridDayObjects.length > 35 ? '25.5rem' : '21.5rem'}}>
        {calendarGridDayObjects.map((day, key) => {
          const isToday = moment().format('YYYY-MM-DD') === moment(day.dateString).format('YYYY-MM-DD')
          const isAfter = moment(day.dateString).isAfter(moment())

          const listPostsValueProcesed = listPost?.value ?listPost?.value :[]
          const postsInDay = listPostsValueProcesed.filter(({ post }) => moment(post.post_date).format('YYYY-MM-DD') === moment(day.dateString).format('YYYY-MM-DD')).map((post) => {

            return (isAfter || isToday) ? {
              image: imagesMapped[`${post.platform}Active`], ...post
             } : {
              image:imagesMapped[post.platform], ...post}
          }) 
          return <div
            key={day.dateString}
            onClick={() => {
              setMobilePosts(postsInDay)
              setDayClickedNow(day.dateString)
              setIsTodayClicked(moment().format('YYYY-MM-DD') === moment(day.dateString).format('YYYY-MM-DD'))
              setIsAfterClicked(moment(day.dateString).isAfter(moment()))
            }}  
            className={classNames("day-grid-item-container", {
              "weekend-day": isWeekendDay(day.dateString),
              "current-month": day.isCurrentMonth
            })}
          >
            <div  key={day} className="day-content-wrapper">{<RenderDay profileSelected={profileSelected.value} dayClickedNow={dayClickedNow} isGenerateModal={true} postsInDay={postsInDay} setModalOpen={setModalOpen} modalOpen={modalOpen} setIsAfterClicked={setIsAfterClicked} setIsTodayClicked={setIsTodayClicked} setMobilePosts={setMobilePosts} calendarDayObject={day} setDaysSelected={setDaysSelected} updateListPost={updateListPost} />}</div>
          </div>
})}

      </div>
     
    </div>
    <div>
     {window.innerWidth < 600 && 
      <div>
      {mobilePosts.map((post, key) => { 
        return <div style={{backgroundColor:post.status === 'error' ? '#f7cac6' : post.status === 'success' ? '#daece4' : '#f8f8f8', paddingTop:'10px', paddingBottom:'5px', marginBottom:'0.4rem'}} key={key}><PostPanel profileSelected={profileSelected.value} mobile post={post} isCalendar updateListPost={updateListPost} /></div>
      })}
      </div>
      }

{(isAfterClicked || isTodayClicked) && window.innerWidth < 600 &&
<Box  onClick={() => setModalOpen(true)}  sx={{backgroundColor:'#f8f8f8', padding:'10px', display:'flex', justifyContent:'center', cursor:'pointer', fontSize:'1rem', marginRight:'0.2rem', color:'#721384'}}>
  <AddIcon sx={{ fontSize:'1rem', position:'relative', top:'0.3rem', }} /> add post
  </Box>
  
}
</div>
    </Box>
  );
}

CalendarDayHeader.propTypes = {
  calendarDayObject: PropTypes.object.isRequired
};
export function CalendarDayHeader({ dayClickedNow, calendarDayObject, isToday }) {
  return dayClickedNow && window.innerWidth < 600 ? (<div className={"day-grid-item-header-today"} style={{color: 'white', backgroundColor:'#721384'}}>{calendarDayObject.dayOfMonth}</div>) : isToday ? (<div className="day-grid-item-header-today" style={{backgroundColor:window.innerWidth > 600 && '#721384', color:window.innerWidth > 600 && 'white'}}>{calendarDayObject.dayOfMonth}</div>) : (
    <div className="day-grid-item-header">{calendarDayObject.dayOfMonth}</div>
  );
}